import type { TablePluginOptions } from '@atlaskit/editor-plugin-table';

interface Props {
	options: Pick<
		TablePluginOptions,
		| 'tableOptions'
		| 'dragAndDropEnabled'
		| 'fullWidthEnabled'
		| 'wasFullWidthEnabled'
		| 'getEditorFeatureFlags'
	>;
}

export function tablePluginOptions({ options }: Props): TablePluginOptions {
	return {
		tableOptions: options.tableOptions,
		dragAndDropEnabled: options.dragAndDropEnabled,
		isTableScalingEnabled: true,
		allowContextualMenu: true,
		fullWidthEnabled: options.fullWidthEnabled,
		wasFullWidthEnabled: options.wasFullWidthEnabled,
		getEditorFeatureFlags: options.getEditorFeatureFlags,
		isCommentEditor: false,
		isChromelessEditor: false,
	};
}
